export const SearchOnPress = (event, Searchfunction) => {
    if (event.key === 'Enter') {
        if (Searchfunction) {
            Searchfunction()
        }
    }

}